import React, { useEffect, useState } from 'react';
import { Alert, Snackbar, Portal } from "@mui/material";

export const Toastr = ({ message, errors, status }) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (message || errors || status) {
            const hasError = status === 'error' || Object.keys(errors || {}).length > 0;
            const shouldShow = (message && message.trim() !== '') || hasError || status === 'success';
            setOpen(shouldShow);
        }
    }, [message, errors, status]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
    };

    const getSeverity = () => {
        if (status === 'error' || Object.keys(errors || {}).length > 0) return 'error';
        if (status === 'success') return 'success';
        return 'info';
    };

    if (!open || !message) return null;

    // Portal: main Container uses zIndex 9 while AppBar is drawer+1 (~1201).
    // Without portal, fixed Snackbar stays in that stacking context and paints under the AppBar.
    return (
        <Portal>
            <Snackbar
                open={open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{ zIndex: (theme) => theme.zIndex.snackbar }}
                onClose={handleClose}
            >
                <Alert severity={getSeverity()} sx={{ mt: 2, mr: 2 }}>
                    {message}
                </Alert>
            </Snackbar>
        </Portal>
    );
}
